import { Button, Switch } from '@mgh-app/component-library';
import { FormControlLabel, FormGroup } from '@mui/material';
import { useAuth } from 'auth/useAuth';
import { MainLayoutContext } from 'layouts/MainLayout';
import { useAppNavigation } from 'navigation/useAppNavigation';
import { FC, PropsWithChildren, useContext, useEffect, useState } from 'react';
import {
  useGetConsentQuery,
  useSaveConsentMutation,
} from 'services/HomeManagementApi/UnitsManagementService';
import {
  borderColor,
  borderRadius,
  borderWidth,
  boxShadow,
  display,
  flexDirection,
  fontWeight,
  gap,
  gridTemplateColumns,
  gridTemplateRows,
  justifyContent,
  margin,
  overflow,
  padding,
  textAlign,
  textColor,
  twCls,
} from 'style';

const ParagraphTitle: FC<PropsWithChildren> = ({ children }) => (
  <h3 className={twCls(textColor('text-blue-100'), fontWeight('font-semibold'))}>{children}</h3>
);

export type DataConsentProps = {
  navigationButtons?: boolean;
};

export const DataConsent: FC<DataConsentProps> = ({ navigationButtons }) => {
  const { showNavigationButtons, setTitle } = useContext(MainLayoutContext);
  const { user } = useAuth();
  const { navigateHome } = useAppNavigation();
  const { data } = useGetConsentQuery({ unitId: user?.unitId || '' });
  const [consent, setConsent] = useState<boolean>(data?.consented || false);
  const [saveConsent] = useSaveConsentMutation();

  useEffect(() => {
    showNavigationButtons(!!navigationButtons);
    setTitle('Data Collection');
  }, [navigationButtons, setTitle, showNavigationButtons]);

  const onContinue = async () => {
    await saveConsent({
      consented: consent,
      unitId: user?.unitId || '',
    });

    navigateHome();
  };

  return (
    <div
      className={twCls(
        display('grid'),
        gridTemplateColumns('grid-cols-1'),
        gridTemplateRows('grid-rows-min-fc-min'),
        gap('gap-6'),
        margin('mt-6'),
      )}
    >
      <h2 className={twCls(textAlign('text-center'))}>Your opt-in and consent</h2>
      <div
        className={twCls(
          borderColor('border-grey-800'),
          borderRadius('rounded-lg'),
          borderWidth('border'),
          boxShadow('shadow-shades-inner-2'),
          padding('p-3'),
          display('grid'),
          gridTemplateColumns('grid-cols-1'),
          gridTemplateRows('grid-rows-fc-min'),
        )}
      >
        <div
          className={twCls(
            overflow('overflow-auto'),
            display('flex'),
            flexDirection('flex-col'),
            gap('gap-6'),
          )}
        >
          <div>
            <ParagraphTitle>How we use your data</ParagraphTitle>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
              dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
              mollit anim id est laborum.
            </p>
          </div>
          <div>
            <ParagraphTitle>How we protect your data</ParagraphTitle>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
              dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
              mollit anim id est laborum.
            </p>
          </div>
          <div>
            <ParagraphTitle>Your right to change your mind</ParagraphTitle>
            <p>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor
              incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud
              exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure
              dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.
              Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt
              mollit anim id est laborum.
            </p>
          </div>
        </div>
        <div>
          <FormGroup>
            <FormControlLabel
              className={twCls(justifyContent('justify-center'))}
              control={
                <Switch
                  name="consentSwitch"
                  checked={consent}
                  onChange={(ev) => setConsent(ev.target.checked)}
                />
              }
              labelPlacement="start"
              label="I consent to the above"
            />
          </FormGroup>
        </div>
      </div>
      <Button onClick={onContinue}>Continue</Button>
    </div>
  );
};
